import * as Billing from '@Modules/Billing';
import { RouteObject } from 'react-router';
import { setupModuleRouting } from './setupModuleRouting';

export function setupBillingRouting(): RouteObject {
    return {
        path: 'billing',
        children: [
            setupModuleRouting({
                resourcePath: 'invoices',
                editFrame: <Billing.FrameEditInvoice />,
                listFrame: <Billing.FrameListInvoice />,
            }),
            {
                path: 'invoices/create',
                element: <Billing.FrameCreateInvoices />,
            },
            setupModuleRouting({
                resourcePath: 'cash_registers',
                editFrame: <Billing.FrameEditCashRegister />,
                listFrame: <Billing.FrameListCashRegister />,
            }),
            setupModuleRouting({
                resourcePath: 'cash_journals',
                editFrame: <Billing.FrameEditCashJournal />,
                listFrame: <Billing.FrameListCashJournal />,
            }),
            setupModuleRouting({
                resourcePath: 'price_lists',
                editFrame: <Billing.FrameEditPriceList />,
                listFrame: <Billing.FrameListPriceList />,
            }),
        ],
    };
}
